/* OHUME V3 — interactions légères (vanilla, sans dépendance) */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function play(v) { try { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }

  /* Vidéos : lecture auto muette uniquement quand elles sont visibles */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) {
        if (v.hasAttribute('data-poster')) { v.poster = v.getAttribute('data-poster'); v.removeAttribute('data-poster'); }
        if (v.preload === 'none') v.preload = 'auto';
        if (!reduce || v.hasAttribute('data-ohv3-force')) play(v);
      } else if (!v.paused) { v.pause(); }
    });
  }, { rootMargin: '150px 0px', threshold: 0.2 }) : null;
  /* Images d'attente des vidéos : posées à l'approche de la section (toute la section d'un coup, pour les rails) */
  function setPosters(sec) { $$('video[data-poster]', sec).forEach(function (v) { v.poster = v.getAttribute('data-poster'); v.removeAttribute('data-poster'); }); }
  var pio = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { pio.unobserve(en.target); setPosters(en.target); } });
  }, { rootMargin: '800px 0px' }) : null;
  function initVideos(root) {
    $$('video[data-ohv3-video]', root).forEach(function (v) {
      if (v.dataset.ohv3Init) return; v.dataset.ohv3Init = '1';
      v.muted = true; v.setAttribute('muted', '');
      if (v.hasAttribute('data-poster')) {
        var sec = v.closest('.shopify-section') || v.parentElement;
        if (!pio) setPosters(sec); else if (!sec.dataset.ohv3Pio) { sec.dataset.ohv3Pio = '1'; pio.observe(sec); }
      }
      if (io) io.observe(v); else play(v);
    });
  }

  /* Rails : flèches précédent / suivant */
  function railStep(rail) { var c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 14 : rail.clientWidth * .8; }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ohv3-prev],[data-ohv3-next]');
    if (!b) return;
    var id = b.getAttribute('data-ohv3-prev') || b.getAttribute('data-ohv3-next');
    var rail = document.getElementById(id); if (!rail) return;
    var dir = b.hasAttribute('data-ohv3-prev') ? -1 : 1;
    var w = Math.max(railStep(rail), rail.clientWidth * 0.8);
    var target = Math.max(0, Math.min(rail.scrollWidth - rail.clientWidth, rail.scrollLeft + dir * w));
    rail.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
    setTimeout(function () { if (Math.abs(rail.scrollLeft - target) > 4) rail.scrollTo({ left: target }); }, 700);
  });

  /* Collection en bulles : pastilles de coloris */
  function initStrip(root) {
    $$('[data-ohv3-strip]', root).forEach(function (strip) {
      if (strip.dataset.ohv3Init) return; strip.dataset.ohv3Init = '1';
      var sec = strip.closest('section');
      var cards = $$('.ohv3-sp', strip);
      var pills = $$('.ohv3-colpill', sec);
      var note = sec.querySelector('[data-ohv3-colornote]');
      var cur = '';
      function parse(el, k) { try { return JSON.parse(el.getAttribute(k) || '{}'); } catch (e) { return {}; } }
      function apply() {
        cards.forEach(function (card) {
          var col = cur || card.dataset.def;
          var imgs = parse(card, 'data-imgs'), bgs = parse(card, 'data-bgs'), urls = parse(card, 'data-urls');
          var img = card.querySelector('.ohv3-sp__img');
          if (img && imgs[col]) { img.removeAttribute('srcset'); img.src = imgs[col]; img.alt = (card.dataset.name || '') + ' coloris ' + col.toLowerCase(); }
          if (bgs[col]) card.style.background = bgs[col];
          if (urls[col]) card.href = urls[col];
        });
        pills.forEach(function (p) { p.setAttribute('aria-pressed', p.dataset.color === cur ? 'true' : 'false'); });
        if (note) note.textContent = cur ? (note.dataset.picked || '').replace('{c}', cur) : note.dataset.empty;
      }
      pills.forEach(function (p) { p.addEventListener('click', function () { cur = (cur === p.dataset.color) ? '' : p.dataset.color; apply(); }); });

    });
  }

  /* Étapes synchronisées avec la vidéo */
  function initSteps(root) {
    $$('[data-ohv3-steps]', root).forEach(function (box) {
      if (box.dataset.ohv3Init) return; box.dataset.ohv3Init = '1';
      var v = box.querySelector('video'); var steps = $$('.ohv3-step', box);
      var times = steps.map(function (s) { return parseFloat(s.dataset.time) || 0; });
      function set(i) { steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-pressed', k === i ? 'true' : 'false'); }); }
      if (v) v.addEventListener('timeupdate', function () {
        var t = v.currentTime, i = 0;
        times.forEach(function (st, k) { if (t >= st - 0.05) i = k; });
        set(i);
      });
      steps.forEach(function (s, k) {
        s.addEventListener('click', function () { set(k); if (v) { try { v.currentTime = times[k] + 0.01; } catch (e) {} play(v); } });
      });
    });
  }

  /* Entretien : slider */
  function initCare(root) {
    $$('[data-ohv3-care]', root).forEach(function (box) {
      if (box.dataset.ohv3Init) return; box.dataset.ohv3Init = '1';
      var n = $$('.ohv3-care__slide', box).length, i = 0;
      var card = box.querySelector('.ohv3-care__card');
      function go(k) {
        i = (k + n) % n;
        ['.ohv3-care__slide', '.ohv3-care__num', '.ohv3-care__text', '.ohv3-care__tab'].forEach(function (sel) {
          $$(sel, box).forEach(function (el) { var on = parseInt(el.dataset.i, 10) === i; el.classList.toggle('is-active', on); if (el.matches('button')) el.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        });
        var t = box.querySelector('.ohv3-care__text.is-active'); if (card && t && t.dataset.bg) card.style.background = t.dataset.bg;
      }
      var prev = box.querySelector('[data-care-prev]'), next = box.querySelector('[data-care-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      $$('.ohv3-care__tab', box).forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); go(parseInt(t.dataset.i, 10)); }); });
      /* Glisser la photo au doigt fait aussi défiler */
      var media = box.querySelector('.ohv3-care__media'), x0 = null;
      if (media) {
        media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        media.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); }, { passive: true });
      }
      go(0);
    });
  }

  /* En-tête transparent si la page commence par le hero vidéo */
  function initHeader() {
    var main = document.getElementById('main');
    var first = main && main.querySelector('.shopify-section');
    var on = !!(first && first.querySelector('.ohv3-hero'));
    document.documentElement.classList.toggle('ohv3-transparent', on);
    if (!on) { document.documentElement.style.removeProperty('--ohv3-header-h'); return; }
    var h = document.querySelector('.shopify-section--header');
    function size() { if (h) document.documentElement.style.setProperty('--ohv3-header-h', h.offsetHeight + 'px'); }
    size(); window.addEventListener('resize', size);
    if (window.ResizeObserver && h) new ResizeObserver(size).observe(h);
  }


  /* Prix au format « 1 337 € » */
  function euro(c) {
    c = Math.round(c || 0);
    if (c % 100) return (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
    return String(c / 100).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  }

  /* Fiche produit */
  function initPdp(root) {
    $$('[data-ohv3-pdp]', root).forEach(function (sec) {
      if (sec.dataset.ohv3Init) return; sec.dataset.ohv3Init = '1';
      var data; try { data = JSON.parse(sec.querySelector('[data-ohv3-pdp-data]').textContent); } catch (e) { return; }
      var form = sec.querySelector('#ohv3-pf'), idInput = sec.querySelector('[data-variant-id]'), qtyInput = sec.querySelector('[data-qty-input]');
      var atc = sec.querySelector('[data-atc]'), atcLab = sec.querySelector('[data-atc-label]'), err = sec.querySelector('[data-atc-error]');
      var track = sec.querySelector('[data-gal-track]'), thumbs = $$('.ohv3-th', sec), slides = $$('.ohv3-gal__slide', sec);
      var cur = data.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || data.variants[0];
      function visibleSlides() { return slides.filter(function (s) { return !s.hidden; }); }
      function setActiveThumb(slide) {
        var key = slide && (slide.hasAttribute('data-da') ? 'da' : slide.getAttribute('data-media-id'));
        thumbs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-i') === key); });
      }
      function goSlide(slide, smooth) { if (!slide || !track) return; track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' }); setActiveThumb(slide); }
      function refresh(init) {
        var col = cur.color, lc = (col || '').toLowerCase();
        idInput.value = cur.id;
        sec.querySelector('[data-price]').innerHTML = euro(cur.price);
        var sp = sec.querySelector('[data-ohv3-split]');
        if (sp) {
          var b3 = sp.querySelector('[data-split3]'), b4 = sp.querySelector('[data-split4]'), w4 = sp.querySelector('[data-split4wrap]');
          if (b3) b3.innerHTML = '3&nbsp;×&nbsp;' + euro(Math.ceil(cur.price / 3));
          if (b4) b4.innerHTML = '4&nbsp;×&nbsp;' + euro(Math.ceil(cur.price / 4));
          if (w4) w4.hidden = cur.price > 200000;
        }
        var cmp = sec.querySelector('[data-compare]'), save = sec.querySelector('[data-save]');
        if (cur.compare > cur.price) { cmp.hidden = false; cmp.innerHTML = euro(cur.compare); save.hidden = false; save.innerHTML = 'Économisez ' + euro(cur.compare - cur.price); }
        else { cmp.hidden = true; save.hidden = true; }
        var stock = sec.querySelector('[data-stock]'); stock.textContent = cur.available ? 'En stock' : 'Épuisé'; stock.className = cur.available ? 'is-in' : 'is-out';
        atc.disabled = !cur.available; updateTotal();
        sec.querySelector('[data-colorname]').textContent = col;
        $$('.ohv3-cdot', sec).forEach(function (b) { var on = b.dataset.color === col; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
        var da = data.da && data.da[col];
        var daSlide = sec.querySelector('[data-da]'), daImg = daSlide && daSlide.querySelector('img'), daTh = sec.querySelector('.ohv3-th[data-i="da"]');
        if (da && daSlide) {
          daSlide.style.background = da.bg; if (daTh) daTh.style.background = da.bg;
          /* au chargement, la photo est déjà la bonne (rendue par le serveur) : on ne la recharge pas */
          if (daImg && da.img && !init) { daImg.removeAttribute('srcset'); daImg.src = da.img; daImg.alt = data.title + ' coloris ' + lc; }
          var ti = daTh && daTh.querySelector('img'); if (ti && da.thumb && !init) { ti.removeAttribute('srcset'); ti.src = da.thumb; }
        }
        slides.concat(thumbs).forEach(function (el) { var c = el.getAttribute('data-color'); el.hidden = !(c === '*' || c === lc); });
        var sp = sec.querySelector('[data-sticky-price]'); if (sp) sp.innerHTML = euro(cur.price);
        var sc = sec.querySelector('[data-sticky-compare]'); if (sc) { sc.hidden = !(cur.compare > cur.price); if (cur.compare > cur.price) sc.innerHTML = euro(cur.compare); }
        var sco = sec.querySelector('[data-sticky-color]'); if (sco) sco.textContent = col;
        var si = sec.querySelector('[data-sticky-img]'); if (si && cur.img && !init) si.src = cur.img;
        try { var u = new URL(location.href); u.searchParams.set('variant', cur.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
        goSlide(visibleSlides()[0], false);
      }
      function updateTotal() { var q = Math.max(1, parseInt(qtyInput.value, 10) || 1); atcLab.innerHTML = cur.available ? 'Ajouter au panier · ' + euro(cur.price * q) : 'Épuisé'; }
      $$('.ohv3-cdot', sec).forEach(function (b) {
        b.addEventListener('click', function () { var v = data.variants.filter(function (x) { return x.color === b.dataset.color; })[0]; if (v) { cur = v; refresh(); } });
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var key = t.getAttribute('data-i');
          var slide = key === 'da' ? sec.querySelector('[data-da]') : sec.querySelector('.ohv3-gal__slide[data-media-id="' + key + '"]');
          goSlide(slide, true);
        });
      });
      if (track) track.addEventListener('scroll', function () {
        clearTimeout(track._t); track._t = setTimeout(function () {
          var vs = visibleSlides(), x = track.scrollLeft, best = vs[0], d = 1e9;
          vs.forEach(function (s) { var dd = Math.abs(s.offsetLeft - track.offsetLeft - x); if (dd < d) { d = dd; best = s; } });
          setActiveThumb(best);
        }, 80);
      }, { passive: true });
      $$('[data-qty]', sec).forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qty, 10)); updateTotal(); }); });
      qtyInput.addEventListener('change', updateTotal);
      form.addEventListener('submit', function (e) {
        e.preventDefault(); if (atc.disabled) return;
        err.hidden = true; atc.classList.add('is-loading'); atc.setAttribute('aria-busy', 'true');
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            atc.classList.remove('is-loading'); atc.removeAttribute('aria-busy');
            if (!res.ok) { err.textContent = res.j.description || res.j.message || "Impossible d'ajouter ce produit."; err.hidden = false; return; }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.show === 'function') { setTimeout(function () { drawer.show(); }, 150); }
            else { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; }
          })
          .catch(function () { atc.classList.remove('is-loading'); form.submit(); });
      });
      /* Barre d'achat collante (téléphone + ordinateur) : visible dès que le bouton d'achat est passé au-dessus de l'écran, jusqu'en bas de la page */
      var sticky = sec.querySelector('[data-ohv3-sticky]');
      if (sticky) {
        var html = document.documentElement, shown = null;
        var check = function () {
          var r = atc.getBoundingClientRect();
          var show = r.bottom < 0;
          if (show === shown) return; shown = show;
          sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          sticky.querySelector('[data-sticky-atc]').tabIndex = show ? 0 : -1;
          html.classList.toggle('galerie-qa-open', show);
          if (show) html.style.setProperty('--galerie-qa-h', sticky.offsetHeight + 'px');
        };
        var tick = null;
        window.addEventListener('scroll', function () { if (tick) return; tick = setTimeout(function () { tick = null; check(); }, 60); }, { passive: true });
        window.addEventListener('resize', check); check();
        sticky.querySelector('[data-sticky-atc]').addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
      }
      refresh(true);
    });
  }

  /* Points produits (Projetez-vous) */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.ohv3-hs__dot');
    $$('.ohv3-hs.is-open').forEach(function (h) { if (!dot || h !== dot.parentElement) { h.classList.remove('is-open'); var d = h.querySelector('.ohv3-hs__dot'); if (d) d.setAttribute('aria-expanded', 'false'); } });
    if (dot) { var h = dot.parentElement, on = !h.classList.contains('is-open'); h.classList.toggle('is-open', on); dot.setAttribute('aria-expanded', on ? 'true' : 'false'); }
  });


  /* Nos canapés : filtre format + coloris */
  function initGrid(root) {
    $$('[data-ohv3-grid]', root).forEach(function (sec) {
      if (sec.dataset.ohv3Init) return; sec.dataset.ohv3Init = '1';
      var cards = $$('.ohv3-card', sec), segs = $$('.ohv3-seg button', sec), dots = $$('.ohv3-cdot', sec), lab = sec.querySelector('[data-grid-cur]');
      var cur = '', f = 'all';
      function parse(el, k) { try { return JSON.parse(el.getAttribute(k) || '{}'); } catch (e) { return {}; } }
      function apply() {
        cards.forEach(function (c) {
          c.hidden = !(f === 'all' || c.dataset.f === f);
          var col = cur || c.dataset.def, imgs = parse(c, 'data-imgs'), bgs = parse(c, 'data-bgs'), urls = parse(c, 'data-urls');
          var ph = c.querySelector('.ohv3-card__ph'), img = ph && ph.querySelector('img');
          if (img && imgs[col]) { img.removeAttribute('srcset'); img.src = imgs[col]; img.alt = (c.dataset.name || '') + ' coloris ' + col.toLowerCase(); }
          if (ph && bgs[col]) ph.style.background = bgs[col];
          if (urls[col]) $$('a', c).forEach(function (a) { a.href = urls[col]; });
          var sub = c.querySelector('[data-sub]'); if (sub) sub.textContent = col;
        });
        segs.forEach(function (b) { var on = b.dataset.f === f; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        dots.forEach(function (d) { d.setAttribute('aria-pressed', d.dataset.color === cur ? 'true' : 'false'); });
        if (lab) lab.textContent = cur || 'tous les coloris';
      }
      segs.forEach(function (b) { b.addEventListener('click', function () { f = b.dataset.f; apply(); }); });
      dots.forEach(function (d) { d.addEventListener('click', function () { cur = cur === d.dataset.color ? '' : d.dataset.color; apply(); }); });
    });
  }


  /* Tiroir panier : boutons − / + autour de la quantité */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ohv3-qstep]'); if (!b) return;
    var inp = b.parentElement.querySelector('input'); if (!inp) return;
    var v = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(b.dataset.ohv3Qstep, 10));
    inp.value = v; inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Couches de matière (une ouverte à la fois) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ohv3-layer'); if (!b) return;
    var box = b.closest('[data-ohv3-layers]');
    $$('.ohv3-layer', box).forEach(function (x) { var on = x === b; x.classList.toggle('is-open', on); x.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    /* Photo de la couche touchée (sinon photo principale) */
    var pics = $$('.ohv3-lay__pic', box); if (!pics.length) return;
    var pic = box.querySelector('.ohv3-lay__pic[data-i="' + b.dataset.i + '"]');
    $$('.ohv3-lay__img', box).forEach(function (im) { im.classList.remove('is-on'); });
    var target = pic ? pic.querySelector('img') : box.querySelector('.ohv3-lay__media > .ohv3-lay__img');
    if (target) { target.loading = 'eager'; target.classList.add('is-on'); }
  });

  /* Inspiration : filtre par coloris */
  function initInspi(root) {
    $$('[data-ohv3-inspi]', root).forEach(function (sec) {
      if (sec.dataset.ohv3Init) return; sec.dataset.ohv3Init = '1';
      var items = $$('.ohv3-it', sec), chips = $$('.ohv3-chipbtn', sec), count = sec.querySelector('[data-in-count]');
      function apply(c) {
        var n = 0;
        items.forEach(function (it) { var on = c === 'all' || it.dataset.c === c; it.hidden = !on; if (on) n++; });
        chips.forEach(function (ch) { var on = ch.dataset.c === c; ch.classList.toggle('is-on', on); ch.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        if (count) count.textContent = n + ' ambiances' + (c === 'all' ? '' : ' en ' + c.toLowerCase());
      }
      chips.forEach(function (ch) { ch.addEventListener('click', function () { apply(ch.dataset.c); }); });
      apply('all');
    });
  }

  /* Panier : quantités sans rechargement complet */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-ohv3-cart-change]'); if (!a) return;
    e.preventDefault();
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: parseInt(a.getAttribute('data-ohv3-cart-change'), 10), quantity: parseInt(a.getAttribute('data-q'), 10) }) })
      .then(function () { window.location.reload(); }).catch(function () { window.location.href = a.href; });
  });

  /* Frise de livraison : « entre le 6 et le 12 nov. » */
  function initEta(root) {
    $$('[data-ohv3-eta]', root).forEach(function (box) {
      var el = box.querySelector('[data-eta-date]'); if (!el || !window.Intl) return;
      var a = parseInt(box.dataset.min, 10) || 16, b = parseInt(box.dataset.max, 10) || 22;
      var d1 = new Date(), d2 = new Date(); d1.setDate(d1.getDate() + a); d2.setDate(d2.getDate() + b);
      var f = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
      var same = d1.getMonth() === d2.getMonth();
      el.textContent = 'entre le ' + (same ? d1.getDate() : f.format(d1)) + ' et le ' + f.format(d2);
    });
  }

  /* Téléphone : accordéons fermés au départ (moins de défilement) */
  function initAcc(root) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 900px)').matches) return;
    $$('.ohv3-pdp__acc details[open], .ohv3-faq details[open]', root).forEach(function (d) { d.open = false; });
  }

  function init(root) { initVideos(root); initEta(root); initAcc(root); initStrip(root); initSteps(root); initCare(root); initPdp(root); initGrid(root); initInspi(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initHeader(); init(); });
  else { initHeader(); init(); }
  document.addEventListener('shopify:section:load', function (e) { initHeader(); init(e.target); });
  window.OHV3 = { init: init };
})();
